import React from 'react';
import Navigation from './Navigation';
import MobileHeader from './MobileHeader';
import MobileBottomNavigation from './MobileBottomNavigation';
import Toast from './Toast';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navigation />
      <MobileHeader />
      <main className="flex-1 p-5 md:p-8 max-w-7xl mx-auto w-full pb-20 md:pb-8">
        {children}
      </main>
      <MobileBottomNavigation />
      <Toast />
    </div>
  );
};

export default Layout; 